let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kJLy8"), load("eQlG4")]).then(() => parcelRequire('32xcy'));